import { ScreenBreakpoints } from 'src/hooks/useBreakpoints';
import { PopupData } from './popup.model';
import { DashboardModalData } from './dashboardModal.model';

export enum WalkmeVisualMode {
    MODAL = 'modal',
    POPUP = 'popup',
    OFF = 'off'
}

export interface WalkmeAdobeTags {
    widgetName: string;
    impression: string;
    close: string;
    next: string;
    skip?: string;
}

export enum ContentVersion {
    PRIMARY = 'primary',
    SECONDARY = 'secondary'
}

export interface WalkmeStep {
    data: DashboardModalData | PopupData;
    dataContentVersion?: ContentVersion; // often this means desktop (PRIMARY) vs mobile (SECONDARY) version of data, but it can mean other things depending on the walkme step
    path: string;
    mode: WalkmeVisualMode;
    adobeTags?: WalkmeAdobeTags;
}

export interface WalkmeModel {
    name: WalkmeName;
    startupStepUserAttributeName: string;
    featureFlagName: string;
    featureFlagEnablementDependsOnDaysSinceReleaseDate: boolean;
    featureFlagReleaseDatePropertyName?: string; // Supply this value in yyyy-mm-dd format in OneXP
    featureFlagDaysToShowAfterReleaseDatePropertyName?: string; // and this value as integer if feature flag enablement by days since release date
    redirectOnFinish: boolean;
    redirectOnFinishUrl?: string;
    steps: WalkmeStep[];
}

export enum WalkmeName {
    TRANSACTION_CLASSIFICATION = 'TransactionClassification'
}

export type GetWalkmeDataFunc = (breakpoints: ScreenBreakpoints) => WalkmeModel;
